const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgSdg11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225px",
    height: "225px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M -0.5,-0.5 C 74.5,-0.5 149.5,-0.5 224.5,-0.5C 224.5,74.5 224.5,149.5 224.5,224.5C 149.5,224.5 74.5,224.5 -0.5,224.5C -0.5,149.5 -0.5,74.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faa12e",
    d: "M 110.5,51.5 C 110.167,65.1829 110.501,78.8496 111.5,92.5C 112.107,92.3764 112.44,92.0431 112.5,91.5C 124.614,81.5888 136.614,71.4222 148.5,61C 150.579,60.1923 152.579,60.359 154.5,61.5C 155.486,79.1196 155.82,96.7863 155.5,114.5C 167.5,114.5 179.5,114.5 191.5,114.5C 191.5,112.167 191.5,109.833 191.5,107.5C 182.494,107.666 173.494,107.5 164.5,107C 162.38,105.477 162.047,103.644 163.5,101.5C 174.819,100.334 186.152,100.168 197.5,101C 198,101.5 198.5,102 199,102.5C 199.667,125.5 199.667,148.5 199,171.5C 198.5,172 198,172.5 197.5,173C 140.167,173.667 82.8333,173.667 25.5,173C 24.1882,166.74 23.5215,160.24 23.5,153.5C 23.6667,147.167 23.8333,140.833 24,134.5C 30.1266,126.705 36.6266,119.205 43.5,112C 45.7008,111.175 47.5341,111.675 49,113.5C 55.0472,120.708 60.8805,128.042 66.5,135.5C 66.5,145.833 66.5,156.167 66.5,166.5C 79.1667,166.5 91.8333,166.5 104.5,166.5C 104.832,129.663 104.498,92.9962 103.5,56.5C 91.5,56.5 79.5,56.5 67.5,56.5C 67.6666,75.8362 67.5,95.1695 67,114.5C 64.6667,117.167 62.3333,117.167 60,114.5C 59.1782,93.1235 59.3449,71.7902 60.5,50.5C 61.0253,49.8076 61.6919,49.3076 62.5,49C 77.8333,48.3333 93.1667,48.3333 108.5,49C 109.756,49.4169 110.423,50.2502 110.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbbb6e",
    d: "M 110.5,51.5 C 111.167,64.8333 111.833,78.1667 112.5,91.5C 112.44,92.0431 112.107,92.3764 111.5,92.5C 110.501,78.8496 110.167,65.1829 110.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfb",
    d: "M 146.5,72.5 C 147.498,103.662 147.832,134.996 147.5,166.5C 135.5,166.5 123.5,166.5 111.5,166.5C 111.333,144.831 111.5,123.164 112,101.5C 123.253,91.4686 134.753,81.802 146.5,72.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbbb6e",
    d: "M 146.5,72.5 C 146.56,71.9569 146.893,71.6236 147.5,71.5C 148.83,103.331 148.83,134.997 147.5,166.5C 147.832,134.996 147.498,103.662 146.5,72.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faa12e",
    d: "M 90.5,71.5 C 96.5548,70.9421 97.8881,73.1088 94.5,78C 89.7915,78.082 88.4582,75.9154 90.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faa131",
    d: "M 75.5,71.5 C 81.5548,70.9421 82.8881,73.1088 79.5,78C 74.7915,78.082 73.4582,75.9154 75.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa9f28",
    d: "M 76.5,85.5 C 80.9764,85.8003 82.3097,87.9669 80.5,92C 74.3389,92.878 73.0055,90.7113 76.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faa02c",
    d: "M 91.5,85.5 C 95.9764,85.8003 97.3097,87.9669 95.5,92C 89.3389,92.878 88.0055,90.7113 91.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faa02c",
    d: "M 134.5,89.5 C 140.016,89.4734 141.349,91.64 138.5,96C 133.57,96.427 132.237,94.2604 134.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faa12f",
    d: "M 75.5,100.5 C 80.8946,99.5548 82.5613,101.555 80.5,106.5C 75.3205,107.647 73.6539,105.647 75.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa9f29",
    d: "M 90.5,100.5 C 96.0159,100.473 97.3492,102.64 94.5,107C 93.1011,107.595 91.7678,107.428 90.5,106.5C 89.3058,104.484 89.3058,102.484 90.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faa02b",
    d: "M 119.5,104.5 C 125.555,103.942 126.888,106.109 123.5,111C 118.791,111.082 117.458,108.915 119.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faa029",
    d: "M 134.5,104.5 C 140.555,103.942 141.888,106.109 138.5,111C 133.791,111.082 132.458,108.915 134.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faa02d",
    d: "M 75.5,115.5 C 81.5548,114.942 82.8881,117.109 79.5,122C 74.7915,122.082 73.4582,119.915 75.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faa12e",
    d: "M 90.5,115.5 C 96.5548,114.942 97.8881,117.109 94.5,122C 89.7915,122.082 88.4582,119.915 90.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa9f29",
    d: "M 120.5,118.5 C 124.935,118.752 126.268,120.919 124.5,125C 118.681,125.526 117.348,123.359 120.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faa02c",
    d: "M 135.5,118.5 C 139.976,118.8 141.31,120.967 139.5,125C 133.36,125.808 132.027,123.641 135.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef7f0",
    d: "M 44.5,120.5 C 48.3014,124.473 51.9681,128.64 55.5,133C 48.5,133.667 41.5,133.667 34.5,133C 38.0469,128.959 41.3802,124.792 44.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fffdfc",
    d: "M 155.5,122.5 C 167.5,122.5 179.5,122.5 191.5,122.5C 191.5,137.167 191.5,151.833 191.5,166.5C 179.5,166.5 167.5,166.5 155.5,166.5C 155.5,151.833 155.5,137.167 155.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faa02e",
    d: "M 91.5,129.5 C 95.9764,129.8 97.3097,131.967 95.5,136C 89.3389,136.878 88.0055,134.711 91.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa9f28",
    d: "M 164.5,129.5 C 168.976,129.8 170.31,131.967 168.5,136C 162.681,136.526 161.348,134.359 164.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa9f28",
    d: "M 179.5,129.5 C 183.707,129.694 185.04,131.694 183.5,135.5C 177.344,136.946 176.011,134.946 179.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faa02d",
    d: "M 76.5,129.5 C 80.9764,129.8 82.3097,131.967 80.5,136C 74.3389,136.878 73.0055,134.711 76.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa9f29",
    d: "M 119.5,133.5 C 124.895,132.555 126.561,134.555 124.5,139.5C 119.321,140.647 117.654,138.647 119.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa9f29",
    d: "M 134.5,133.5 C 140.016,133.473 141.349,135.64 138.5,140C 137.101,140.595 135.768,140.428 134.5,139.5C 133.306,137.484 133.306,135.484 134.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefcfa",
    d: "M 30.5,140.5 C 40.1667,140.5 49.8333,140.5 59.5,140.5C 59.5,149.167 59.5,157.833 59.5,166.5C 55.8333,166.5 52.1667,166.5 48.5,166.5C 48.6657,162.154 48.499,157.821 48,153.5C 46,150.833 44,150.833 42,153.5C 41.501,157.821 41.3343,162.154 41.5,166.5C 37.8333,166.5 34.1667,166.5 30.5,166.5C 30.5,157.833 30.5,149.167 30.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fba02e",
    d: "M 120.5,147.5 C 123.352,147.352 125.019,148.686 125.5,151.5C 123.167,156.833 120.833,156.833 118.5,151.5C 118.752,149.927 119.418,148.594 120.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faa131",
    d: "M 134.5,148.5 C 140.555,147.942 141.888,150.109 138.5,155C 133.791,155.082 132.458,152.915 134.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcd1a6",
    d: "M 103.5,56.5 C 104.498,92.9962 104.832,129.663 104.5,166.5C 91.8333,166.5 79.1667,166.5 66.5,166.5C 66.5,156.167 66.5,145.833 66.5,135.5C 67.494,145.319 67.8274,155.319 67.5,165.5C 79.5,165.5 91.5,165.5 103.5,165.5C 103.5,129.167 103.5,92.8333 103.5,56.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdg11);
export default __webpack_public_path__ + "static/media/sdg11.2cfaccf9a3161f88261d988646dea8e9.svg";
export { ForwardRef as ReactComponent };